import React from 'react';
import Card from '../../components/ui/Card/Card';
import Input from '../../components/ui/Input/Input';
import Button from '../../components/ui/Button/Button';
import Pager from '../../components/ui/Pager/Pager';
import { SearchIcon } from '../../components/ui/Icons';
import { useLayout } from '../../layout/LayoutContext';
import { useDeliveries } from './useDeliveries';
import DeliveriesSkeleton from './DeliveriesSkeleton';
import styles from './Deliveries.module.css';

const Deliveries: React.FC = () => {
  const {
    deliveries,
    loading,
    search,
    setSearch,
    openDetail,
    goCreate,
    page,
    setPage,
    pageSize,
    setPageSize,
    total,
    totalPages,
  } = useDeliveries();

  const { setHideHeader } = useLayout();
  React.useEffect(() => {
    setHideHeader(true);
    return () => setHideHeader(false);
  }, [setHideHeader]);

  if (loading && deliveries.length === 0) return <DeliveriesSkeleton />;

  return (
    <div className={`${styles.page} dylo-animate-in`}>
      <Card className={loading ? 'dylo-loading-host' : undefined}>
        {loading && <span className="dylo-loading-sweep" aria-label="Loading" />}

        <div className={styles.header}>
          <h1 className={styles.title}>Deliveries</h1>
          <div className={styles.headerActions}>
            <Button variant="primary" className={styles.newBtn} onClick={goCreate}>
              + New Delivery
            </Button>
            <div className={styles.search}>
              <Input
                icon={<SearchIcon size={17} />}
                placeholder="Search"
                value={search}
                onChange={(e) => setSearch(e.target.value)}
              />
            </div>
          </div>
        </div>

        <div className={styles.tableWrap}>
          <div className={styles.tableHead}>
            <span>Name</span>
            <span>SCAC</span>
            <span>Mail</span>
            <span>Phone</span>
            <span>Client</span>
            {/* Sin columna "User" desde el 13-oct-2026: ligaba la bodega a un usuario del rol Delivery, que se quitó
                (PENDIENTES_TERRESTRE, punto 9). */}
            <span className={styles.center}>Actions</span>
          </div>

          <div className={styles.tableBody}>
            {deliveries.length === 0 ? (
              <div className={styles.empty}>No deliveries found.</div>
            ) : (
              deliveries.map((d, i) => (
                <div key={d.id} className={styles.row} style={{ animationDelay: `${Math.min(i, 12) * 0.03}s` }}>
                  <span className={styles.name}>{d.name}</span>
                  <span className={styles.muted}>{d.scac || '—'}</span>
                  <span className={styles.muted}>{d.email || '—'}</span>
                  <span className={styles.muted}>{d.phone || '—'}</span>
                  <span>{d.client?.name || '—'}</span>
                  <span className={styles.center}>
                    <Button variant="ghost" className={styles.detailBtn} onClick={() => openDetail(d.id)}>
                      Detail
                    </Button>
                  </span>
                </div>
              ))
            )}
          </div>
        </div>

        {/* Sin resultados no se pinta: quedarían flechas inertes debajo de "No deliveries found." */}
        {total > 0 && (
          <Pager
            page={page}
            totalPages={totalPages}
            onChange={setPage}
            total={total}
            pageSize={pageSize}
            itemLabel="delivery"
            itemLabelPlural="deliveries"
            pageSizeOptions={[25, 50, 100]}
            onPageSizeChange={setPageSize}
          />
        )}
      </Card>
    </div>
  );
};

export default Deliveries;
